/**
 * Componente principal de la aplicación
 * Demo Bizantino Gelato - Sistema de Gestión Nutricional
 */
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import esES from "antd/locale/es_ES";
import { BranchProvider } from "./context/BranchContext";
import MainLayout from "./components/layout/MainLayout";
import Dashboard from "./pages/Dashboard";
import Branches from "./pages/Branches";
import NutritionalIngredients from "./pages/NutritionalIngredients";
import Recipes from "./pages/Recipes";
import NutritionLabels from "./pages/NutritionLabels";

function App() {
  return (
    <ConfigProvider locale={esES}>
      <BranchProvider>
        <Router>
          <MainLayout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/branches" element={<Branches />} />
              <Route path="/ingredients" element={<NutritionalIngredients />} />
              <Route path="/recipes" element={<Recipes />} />
              <Route path="/labels" element={<NutritionLabels />} />
            </Routes>
          </MainLayout>
        </Router>
      </BranchProvider>
    </ConfigProvider>
  );
}

export default App;

